import React from "react";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import Login from "../../auth/Login";
import SocioDemographic from "./SocioDemographic";
const SocioDemographicIndex = () => {
  return (
    <div>
      <AuthenticatedTemplate>
        <SocioDemographic />
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </div>
  );
};

export default SocioDemographicIndex;
